module.exports = __webpack_public_path__ + "img/plus-circle.3da31371.png";